<ngx-extended-pdf-viewer class="h-100 w-100 position-absolute" src="assets/pdfs/privacy_policy.pdf" [sidebarVisible]="false" [showToolbar]="false" />

